import { jsx as a } from "react/jsx-runtime";
import e from "./chat.js";
const u = ({
  accountsJwt: r,
  currentUser: o,
  hyperflowConfig: p,
  hyperflowJwt: t
}) => /* @__PURE__ */ a(
  e,
  {
    accountsJwt: r,
    currentUser: o,
    hyperflowConfig: p,
    hyperflowJwt: t
  }
);
export {
  u as default
};
//# sourceMappingURL=index.js.map
